import { encodePeriodValue } from '@components'

import { useItemsPerPage } from '@billy/design-system'
import { useMemo } from 'react'

import { defaultQuery } from '@features/invoices/elements/InvoicesList/context/invoicesListFilters'
import { useFetchSalesDocuments } from '@features/invoices/hooks/useFetchSalesDocuments'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useGlobalFiscalYear } from '../../../../../contexts/globalFiscalYearContext'
import { getPeriodValueFromFiscalYear } from '../../../../../utils/getPeriodValueFromFiscalYear'

export const usePrefetchClientInvoices = (customerId?: string) => {
  const [pageSize] = useItemsPerPage()
  const { fiscalYear } = useGlobalFiscalYear()
  const { organization } = useUserOrganization()

  const period = useMemo(
    () =>
      fiscalYear && organization?.id
        ? encodePeriodValue(getPeriodValueFromFiscalYear(fiscalYear), organization.id)
        : undefined,
    [fiscalYear, organization?.id],
  )

  const { isLoading } = useFetchSalesDocuments({
    customerId,
    documentsListType: 'invoices',
    isEnabled: !!customerId,
    page: defaultQuery.page,
    pageSize,
    period,
    sortDirection: defaultQuery.sortDirection,
    sortProperty: defaultQuery.sortProperty,
  })

  return { isLoading: !!customerId && isLoading }
}
